import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import determinarPaginaAtualAgencia from '../../actions/agencia/determinarPaginaAtualAgencia'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoAgencia extends Component {
  render () {
    return <BotoesPaginacao
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtualAgencia}/>
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualAgencia,
    total: state.agencias.total,
    registrosPorPagina: state.registrosPorPaginaAgencia
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({ determinarPaginaAtualAgencia }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoAgencia)
